const DISPLAY_EPSILON = 1e-9;

export function formatQty(value: number | null | undefined): string {
  if (value == null) return '—';
  if (Math.abs(value) < DISPLAY_EPSILON) return '0';
  if (value % 1 === 0) return String(value);
  if (Math.abs(value) >= 1) return parseFloat(value.toFixed(3)).toString();
  return parseFloat(value.toFixed(4)).toString();
}

/** Display rule for summary stat cards:
 *  - whole numbers → no decimals
 *  - |value| >= 1  → max 2 decimal places
 *  - |value| < 1   → up to 3 decimal places
 */
export function formatCardQty(value: number | null | undefined): string {
  if (value == null) return '—';
  if (Math.abs(value) < DISPLAY_EPSILON) return '0';
  if (value % 1 === 0) return String(value);
  if (Math.abs(value) >= 1) return parseFloat(value.toFixed(2)).toString();
  return parseFloat(value.toFixed(3)).toString();
}

export function formatQtyWithUnit(value: number | null | undefined, unit: string): string {
  return `${formatQty(value)} ${unit}`;
}
